import { useEffect } from 'react';
import PageLoader from './PageLoader';

const PageRedirector = ({ link }) => {
    useEffect(() => window.location.replace(link));
    return <PageLoader />;
};

export default PageRedirector;
